import React from 'react';
import { getGlobalTheme } from '@atlaskit/tokens';
import { ConfluenceDarkTheme } from '../../assets/confluence/dark-theme';
import { ConfluenceLightTheme } from '../../assets/confluence/light-theme';
import { DesktopOnlyBackground } from '../../common/ui';
export var ConfluenceBackground = function ConfluenceBackground(_ref) {
  var children = _ref.children;
  var isDarkMode = getGlobalTheme().colorMode === 'dark';
  var Background = isDarkMode ? ConfluenceDarkTheme : ConfluenceLightTheme;
  return /*#__PURE__*/React.createElement(DesktopOnlyBackground, {
    background: Background
  }, children);
};